import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import InsulatorDetail from "@/pages/InsulatorDetail";
import Collection from "@/pages/Collection";
import CollectionMap from "@/pages/CollectionMap";
import CollectionPassportPage from "@/pages/CollectionPassportPage";
import AddInsulator from "@/pages/AddInsulator";
import Forum from "@/pages/Forum";
import ForumTopic from "@/pages/ForumTopic";
import Messages from "@/pages/Messages";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import Advertise from "@/pages/Advertise";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Rules from "@/pages/Rules";
import Trades from "@/pages/Trades";
import Leaderboard from "@/pages/Leaderboard";
import UserProfile from "@/pages/UserProfile";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin-login" element={<Login admin />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/catalog" element={<Catalog />} />
                  <Route path="/catalog/:id" element={<InsulatorDetail />} />
                  <Route path="/collection/map" element={<CollectionMap />} />
                  <Route path="/collection/passport" element={<ProtectedRoute><CollectionPassportPage /></ProtectedRoute>} />
                  <Route path="/advertise" element={<Advertise />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/rules" element={<Rules />} />
                  <Route path="/u/:userId" element={<UserProfile />} />
                  <Route path="/leaderboard" element={<Leaderboard />} />
                  <Route path="/trades" element={<ProtectedRoute><Trades /></ProtectedRoute>} />
                  <Route path="/forum" element={<Forum />} />
                  <Route path="/forum/:id" element={<ForumTopic />} />
                  <Route path="/collection" element={<ProtectedRoute><Collection /></ProtectedRoute>} />
                  <Route path="/contribute" element={<ProtectedRoute><AddInsulator /></ProtectedRoute>} />
                  <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                  <Route path="/messages/:userId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                  <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                  <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
